<template>
<div class="flex">
  <div class="flex flex-col video-vertical-tabs" :class="wrapperClass">
    <button
      type="button"
      v-for="tab in tabs"
      :key="tab.value"
      :ref="tab.value"
      :class="[
        'px-6 py-3 w-full text-left focus:outline-none text-sm',
        { 'current-tab text-primary font-bold': tab === selected },
      ]"
      :disabled="tab.disabled || false"
      @click="openTab(tab)"
    >
      {{tab}}
    </button>
  </div>
  <div v-for="tab in tabs" class="w-full" :class="contentClass" v-show="selected === tab" :key="tab">
    <slot :name="tab"></slot>
  </div>
</div>
</template>
<script>
export default {
  name: 'VerticalTabs',
  props: {
    tabs: {
      type: Array,
      required: true,
    },
    wrapperClass: {
      type: String,
      required: false,
    },
    contentClass: {
      type: String,
      required: false,
    },
    activeByDefault: {
      type: String,
      required: false,
    },
    tabClass: {
      type: String,
      required: false,
    },
    tabActiveClass: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      selected: null,
    };
  },
  watch: {
    tabs() {
      this.selected = this.tabs[0];
    },
  },
  mounted() {
    const tab = this.activeByDefault || this.tabs[0];
    this.openTab(tab);
  },
  methods: {
    openTab(tab) {
      this.selected = tab;
      this.$emit('tab-change', tab);
    },
  },
};
</script>
<style lang="scss">
.current-tab {
  background-color: transparent;
  position: relative;
  &:before {
    content: '';
    position: absolute;
    inset: 0;
    background-color: var(--brand-primary);
    opacity: 0.1;
  }
}
.video-vertical-tabs {
  max-width: 300px;
}
</style>